module.exports = __webpack_public_path__ + "static/media/javaScriptLogo.d4e9a58b.png";